// use this file to keep an index of grids
// and their corresponding grid components
import { ReactElement } from 'react';

import GridType0 from '~/components/casino-shared/explore/grids/grid-type-0';
import GridType1 from '~/components/casino-shared/explore/grids/grid-type-1';
import GridType2 from '~/components/casino-shared/explore/grids/grid-type-2';
import GridType3 from '~/components/casino-shared/explore/grids/grid-type-3';
import GridType4 from '~/components/casino-shared/explore/grids/grid-type-4';
import GridType5 from '~/components/casino-shared/explore/grids/grid-type-5';
import GridType6 from '~/components/casino-shared/explore/grids/grid-type-6';

import { jackpotGridEnum } from '~/components/casino-shared/subnavigation/constants';
import JackpotGridFancy from '~/components/casino-shared/explore/grids/jackpot-grid-fancy';
import JackpotGridMultiplePool from '~/components/casino-shared/explore/grids/jackpot-grid-multiple-pool';

type GridComponentProps = {
	GameCards: ReactElement<unknown>[];
	categoryType: string;
	itemDisplayType: string;
	allowIncompleteUnits?: boolean;
	gridUnitSupport?: boolean;
	JackpotCard?: ReactElement<unknown>;
};

type TemplateEntry = {
	GridComponent: React.ComponentType<GridComponentProps>;
	nrMinimumItems: number;
	smallUnitSize: { width: number; height: number };
	bigUnitSize: { width: number; height: number };
};

export const templates = {
	0: {
		GridComponent: GridType0,
		nrMinimumItems: 0,
		smallUnitSize: { width: 0, height: 0 },
		bigUnitSize: { width: 0, height: 0 }
	},
	1: {
		GridComponent: GridType1,
		nrMinimumItems: 5,
		smallUnitSize: { width: 336, height: 278 },
		bigUnitSize: { width: 510, height: 423 }
	},
	2: {
		GridComponent: GridType2,
		nrMinimumItems: 11,
		smallUnitSize: { width: 800, height: 220 },
		bigUnitSize: { width: 1206, height: 336 }
	},
	3: {
		GridComponent: GridType3,
		nrMinimumItems: 3,
		smallUnitSize: { width: 510, height: 162 },
		bigUnitSize: { width: 684, height: 220 }
	},
	4: {
		GridComponent: GridType4,
		nrMinimumItems: 3,
		smallUnitSize: { width: 510, height: 244 },
		bigUnitSize: { width: 684, height: 330 }
	},
	5: {
		GridComponent: GridType5,
		nrMinimumItems: 9,
		smallUnitSize: { width: 336, height: 336 },
		bigUnitSize: { width: 510, height: 510 }
	},
	6: {
		GridComponent: GridType6,
		nrMinimumItems: 6,
		smallUnitSize: { width: 336, height: 336 },
		bigUnitSize: { width: 510, height: 510 }
	},
	[jackpotGridEnum.FANCY]: {
		GridComponent: JackpotGridFancy,
		nrMinimumItems: 6,
		smallUnitSize: { width: 327, height: 327 },
		bigUnitSize: { width: 510, height: 336 }
	},
	[jackpotGridEnum.MULTIPLE_POOL]: {
		GridComponent: JackpotGridMultiplePool,
		nrMinimumItems: 4,
		smallUnitSize: { width: 220, height: 220 },
		bigUnitSize: { width: 336, height: 336 }
	},
	[jackpotGridEnum.SIMPLE]: {
		GridComponent: JackpotGridMultiplePool,
		nrMinimumItems: 4,
		smallUnitSize: { width: 220, height: 220 },
		bigUnitSize: { width: 336, height: 336 }
	}
} as const;

const gridTemplates = new Proxy(templates, {
	get: (target, name) => {
		return target[name as unknown as keyof typeof target] ? target[name as unknown as keyof typeof target] : {};
	}
}) as Record<keyof typeof templates, TemplateEntry>;

export default gridTemplates;
